import {
  createSlice,
  createEntityAdapter,
  createSelector,
  EntityId,
  Dictionary,
} from '@reduxjs/toolkit';

import { RootState } from '../../app/store';
import { SnapshotMarker } from '../../types';

const markersAdapter = createEntityAdapter<SnapshotMarker>();

interface ExtraSliceState {
  ids: EntityId[];
  entities: Dictionary<SnapshotMarker>;
}

export const slice = createSlice({
  name: 'markers',
  initialState: markersAdapter.getInitialState({
    selectedMarker: -1,
    trendlineMode: false,
    uneditedState: {
      ids: [],
      entities: {},
    } as ExtraSliceState,
  }),
  reducers: {
    selectedMarkerChanged: (state, { payload }: { payload: number }) => {
      state.selectedMarker = payload;
    },
    trendlineModeToggled: (state, { payload }) => {
      state.trendlineMode = payload;
    },
    markerMoved: (state, { payload }) => {
      if (!payload) return;

      let markerWithId = {
        ...payload,
        id: payload.index + '_TEMP',
      };

      markersAdapter.upsertOne(state, markerWithId);
    },
    removeClientsideMarker: (state, { payload }) => {
      markersAdapter.removeOne(state, payload.id);
    },
    clearClientsideMarkers: (state) => {
      state.ids = [];
      state.entities = {};
      state.uneditedState = {
        ids: [],
        entities: {},
      };
    },
  },
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectedMarkerChanged,
  markerMoved,
  trendlineModeToggled,
  clearClientsideMarkers,
  removeClientsideMarker,
} = slice.actions;

export const { selectAll: selectAllMarkers } = markersAdapter.getSelectors(
  (state: RootState) => state.markers
);

export const selectMarkersBySnapshotId = () =>
  createSelector(
    [selectAllMarkers, (state: RootState, snapshotId: number) => snapshotId],
    (markers, snapshotId) => {
      if (!snapshotId) return [];
      const filteredMarkers = markers.filter(
        (marker) => marker.snapshot_id === snapshotId
      );
      return filteredMarkers;
    }
  );
